export const ConvertObjectInStringParams = (object) => {
  const params = [];

  Object.keys(object).forEach((k) => {
    params.push(`${k}=${object[k]}`);
  });

  return params.join('&');
};
const CreateFiltersParams = (fiterObject, filterString) => {
  let filter = {
    cachedPrice: true,
    Group: true,
    sort: 'SCORE',
    pageSize: 12,
    GroupFeatures: true,
  };
  if (filterString) {
    const filters = JSON.parse(decodeURIComponent(atob(filterString)));
    filter = {
      ...filter,
      ...filters,
    };
  }

  filter = {
    ...filter,
    ...fiterObject,
  };

  return filter;
};
export default CreateFiltersParams;
